export default __webpack_public_path__ + "c994ea111b4fe5ed3b8fe68be72ee05a.png";